import { Int } from '@adornis/baseql/baseqlTypes';
import { Entity, Field } from '@adornis/baseql/decorators';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity';

@Entity()
export class NodeBBTag extends AdornisEntity {
  static _class = 'NodeBBTag';
  @Field(type => String)
  value!: string;
  @Field(type => Int)
  score!: number;
  @Field(type => String)
  valueEscaped!: string;
  @Field(type => String)
  color!: string;
  @Field(type => String)
  bgColor!: string;
}
